import ConnectionsTable from "./ConnectionRequestTable"

export default  ConnectionsTable;



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/ConnectionRequestTable/index.js